<div class="vendor-bill-popup">
    <div class="bill-header">
      <div>
        <h4>Customer Billing</h4>
        <span>{{ selectedOrders.length }} order selected</span>
      </div>
      <span class="vendor-chip">{{ selectedOrders[0]?.customerName || 'Customer' }}</span>
    </div>
  
    <div *ngIf="loading" class="loading-state">
      <p-progressSpinner styleClass="small-spinner"></p-progressSpinner>
      <span>Loading trip and claim details...</span>
    </div>
  
    <ng-container *ngIf="!loading">
      <!-- <div class="summary-strip" [formGroup]="invoiceForm">
        <div class="summary-item">
          <label>Total Amount</label>
          <span>{{ formatAmount(invoiceForm.get('totalAmount')?.value) }}</span>
        </div>
        <div class="summary-item">
          <label>Customer Charge</label>
          <span>{{ formatAmount(invoiceForm.get('customerCharge')?.value) }}</span>
        </div>
      </div> -->
  
      <section class="bill-section">
        <div class="section-title">
          <span class="section-count">1</span>
          <span>Trip Reference</span>
        </div>
  
        <div class="trip-card" *ngFor="let row of tripRows; let i = index">
          <div class="trip-card-main">
            <div>
              <strong>{{ row.orderNumber }}</strong>
              <small>Trip {{ row.tripNumber }}</small>
            </div>
            <span class="claim-chip" [ngClass]="getStatusClass(row.claimStatus)">
              {{ row.claimStatus }}
            </span>
          </div>
  
          <div class="trip-meta-row">
            <div class="meta-item">
              <label>Customer</label>
              <span>{{ row.customerName }}</span>
            </div>
            <div class="meta-item">
              <label>Vehicle</label>
              <span>{{ row.vehicleNumber }}</span>
            </div>
            <!-- <div class="meta-item">
              <label>Advance</label>
              <span>{{ formatAmount(row.advance) }}</span>
            </div>
            <div class="meta-item">
              <label>Claim Amount</label>
              <span>{{ formatAmount(row.claimAmount) }}</span>
            </div> -->
            <div class="meta-item" *ngIf="row.customerCharge > 0">
              <label>Customer Charge</label>
              <span>{{ formatAmount(row.customerCharge) }}</span>
            </div>
          </div>
        </div>
      </section>
  
      <section class="bill-section" [formGroup]="invoiceForm">
        <div class="section-title">
          <span class="section-count">2</span>
          <span>Billing Summary</span>
        </div>
  
        <div class="invoice-grid">
            <div class="invoice-field">
                <label>GST <span class="required">*</span></label>
                <ng-select
                  formControlName="accountGstId"
                  [items]="gstList"
                  bindLabel="gstNumber"
                  bindValue="id"
                  appendTo="body"
                  [loading]="loadingGst"
                  [clearable]="true"
                  placeholder="Select GST">
                  <ng-template ng-option-tmp let-gst="item">
                    {{ getGstLabel(gst) }}
                  </ng-template>
                  <ng-template ng-label-tmp let-gst="item">
                    {{ getGstLabel(gst) }}
                  </ng-template>
                </ng-select>
                <small class="text-danger" *ngIf="isInvalid('accountGstId')">GST is required</small>
              </div>
              
              <div class="invoice-field">
                <label>Customer Address <span class="required">*</span></label>
                <ng-select
                  formControlName="customerAddressId"
                  [items]="customerAddressList"
                  bindLabel="addressLine1"
                  bindValue="id"
                  [loading]="loadingCustomerAddress"
                  [clearable]="true"
                  placeholder="Select Address">
                  <ng-template ng-option-tmp let-address="item">
                    {{ getCustomerAddressLabel(address) }}
                  </ng-template>
                  <ng-template ng-label-tmp let-address="item">
                    {{ getCustomerAddressLabel(address) }}
                  </ng-template>
                </ng-select>
                <small class="text-danger" *ngIf="isInvalid('customerAddressId')">Customer address is required</small>
              </div>
              
          <div class="invoice-field">
            <label>Total Amount</label>
            <input type="text" appIndianNumberFormat  class="form-control" formControlName="totalAmount" readonly />
          </div>
  
          <div class="invoice-field">
            <label>Customer Charge</label>
            <input type="text" appIndianNumberFormat  class="form-control" formControlName="customerCharge" readonly />
          </div>
  
          <div class="invoice-field">
            <label>Total Payable</label>
            <input type="text" appIndianNumberFormat  class="form-control total-input" formControlName="invoiceAmount" readonly />
          </div>
  
          <div class="invoice-field remarks-field">
            <label>Remarks</label>
            <textarea class="form-control" formControlName="remarks" placeholder="Add remarks"></textarea>
          </div>
        </div>
      </section>
  
      <div class="bill-actions">
        <button type="button" class="btn btn-secondary" (click)="ref.close()">Cancel</button>
        <button type="button" class="btn btn-primary" [disabled]="invoiceForm.invalid || saving" (click)="generateBill()">
          Generate Bill
        </button>
      </div>
    </ng-container>
  </div>